import React, { useState, useEffect } from 'react';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import LoadingButton from '@mui/lab/LoadingButton';
import TextField from '@mui/material/TextField';
import { useLocation, useNavigate } from 'react-router-dom';
import { useViewPropertyQuery, useGetPermissionQuery, useUpdatePolicyMutation, useDeletePolicyMutation } from '../../../services/dvagent';
import { Toaster } from '../attributes';
import { getToken, storeAdmin, getUsername } from '../../../services/LocalStorageService';

const commonBorderStyle = {
  border: '1px solid #ccc',
  borderRadius: '10px',
  padding: '10px',
  height: '250px',
  overflowY: 'auto',
};

const listHeaderStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

const listItemStyle = {
  margin: '2px',
  padding: '4px',
  borderRadius: '4px',
  border: '1px solid #ededed',
  cursor: 'move',
  backgroundColor: 'white',
};

const searchInputStyle = {
  margin: '10px 0',
  padding: '2%',
  width: '70%',
  border: '1px solid #ededed',
  borderRadius: '5px',
};

function formatDate(dateString) {
  const date = new Date(dateString);
  const formattedDate = date.toLocaleDateString('en-US', {
    month: 'long',
    day: '2-digit',
    year: 'numeric'
  });
  const formattedTime = date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit'
  });
  return `${formattedDate} ${formattedTime} `;
}

const List = ({
    name,
    items,
    selectedItems,
    searchQuery,
    searchQuery1,
    handleDragStart,
    handleDropItems,
    filteredItems,
    filteredSelectedItems,
    onSearchQueryChange,
    onSearchQuery1Change,
  }) => {
      const handleDragOver = (e) => {
        e.preventDefault();
    };

  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <div
        onDragOver={handleDragOver}
        onDrop={(e) => handleDropItems(e, 'available')}
        style={{
          ...commonBorderStyle,
          flex: 1,
        }}
      >
        <div style={{ ...listHeaderStyle, position: 'sticky', top: -10, zIndex: 1, background: '#F9FAFB' }}>
          <strong style={{ color: "#B7B7B7", fontStyle: "italic", marginLeft: "10%" }}>{name}</strong>
          <input
            type="text"
            placeholder="Search items"
            value={searchQuery}
            onChange={onSearchQueryChange}
            style={searchInputStyle}
          />
        </div>

        {filteredItems
          .filter((item) => !filteredSelectedItems.some((selectedItem) => selectedItem.id === item.id))
          .map((item) => (
            <div
              key={item.id}
              draggable
              onDragStart={(e) => handleDragStart(e, item)}
              style={listItemStyle}
            >
              <Checkbox value={item.id} onChange={(e) => handleDropItems(e, 'selected')}  />
              {item.email} {item.name}
            </div>
          ))}
      </div>
      <div
        onDragOver={handleDragOver}
        onDrop={(e) => handleDropItems(e, 'selected')}
        style={{
          ...commonBorderStyle,
          marginLeft: '20px',
          flex: 1,
        }}
      >
        <div style={{ ...listHeaderStyle, position: 'sticky', top: -10, zIndex: 1, background: '#F9FAFB' }}>
          <strong style={{ color: "#B7B7B7", fontStyle: "italic", marginLeft: "10%" }}>Picked</strong>
          <input
            type="text"
            placeholder="Search items"
            value={searchQuery1}
            onChange={onSearchQuery1Change}
            style={searchInputStyle}
          />
        </div>

        {filteredSelectedItems.map((item) => (
          <div
            key={item.id}
            draggable
            onDragStart={(e) => handleDragStart(e, item)}
            style={{
              ...listItemStyle,
              backgroundColor: '#ccc',
            }}
          ><Checkbox checked value={item.id} onChange={(e) => handleDropItems(e, 'available')}/>
            {item.email} {item.name}
          </div>
        ))}
      </div>
    </div>
  );
};

const Update = (policy) => {

  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const [policyName, setPolicyName] = useState('');
  const [policyNameError, setPolicyNameError] = useState('');
  const [propertyListError, setPropertyListError] = useState('');
  const [permissionListError, setPermissionListError] = useState('');

  const [confirmAction, setConfirmAction] = useState("");
  const [confirmActionError, setConfirmActionError] = useState("");
  const [open, setOpen] = useState(false);
  const [popupTitle, setPopupTitle] = useState('');
  const [popupLogo, setPopupLogo] = useState('');
  const [popupWidth, setPopupWidth] = useState(0);
  const [askUpdatePopup, setAskUpdatePopup] = useState(false);
  const [askDeletePopup, setAskDeletePopup] = useState(false);

  const [property, setProperty] = useState([]);
  const [selectedProperty, setSelectedProperty] = useState([]);
  const [searchPropertyQuery, setSearchPropertyQuery] = useState('');
  const [searchPropertyQuery1, setSearchPropertyQuery1] = useState('');

  const [permission, setPermission] = useState([])
  const [selectedPermission, setSelectedPermission] = useState([]);
  const [searchPermissionQuery, setSearchPermissionQuery] = useState('');
  const [searchPermissionQuery1, setSearchPermissionQuery1] = useState('');

  const [buttonLabel, setButtonLabel] = useState("UPDATE");
  const [UpdatePolicyMutation] = useUpdatePolicyMutation();
  const [DeletePolicyMutation] = useDeletePolicyMutation();
  const { data: propertyData, isSuccess: propretyIsSuccess, error: propertyError } = useViewPropertyQuery({"token":getToken(), "location":location});
  const { data: permisstionData, isSuccess: permisstionIsSuccess, error: permisstionError } = useGetPermissionQuery({"token":getToken(), "location":location});
  const [toasterData, setToasterData] = useState({
    trigger: false,
    status: true,
    symbol: '✔',
    message: '',
  });

  const filteredProperty = property.filter((property) =>
    property.name.toLowerCase().includes(searchPropertyQuery.toLowerCase())
  ).sort((a, b) => a.name.localeCompare(b.name));

  const filteredSelectedProperty = selectedProperty.filter((property) =>
    property.name.toLowerCase().includes(searchPropertyQuery1.toLowerCase())
  ).sort((a, b) => a.name.localeCompare(b.name));

  const filteredPermission = permission.filter((permission) =>
    permission.name.toLowerCase().includes(searchPermissionQuery.toLowerCase())
  ).sort((a, b) => a.name.localeCompare(b.name));

  const filteredSelectedPermission = selectedPermission.filter((permission) =>
    permission.name.toLowerCase().includes(searchPermissionQuery1.toLowerCase())
  ).sort((a, b) => a.name.localeCompare(b.name));

  const handleDragStartProperty = (e, item) => {
    e.dataTransfer.setData('text/plain', String(item.id));
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDragStartPermission = (e, item) => {
    e.dataTransfer.setData('text/plain', String(item.id));
    e.dataTransfer.effectAllowed = 'move';
  };

  const handlePolicyName = (event) => {
    setPolicyName(event.target.value);
    setPolicyNameError('');
  };

  const handleConfirmAction = (event) => {
    setConfirmAction(event.target.value);
    setConfirmActionError("");
  };

  const handleDropSetProperty = (e, targetList) => {
    setPropertyListError('')
    e.preventDefault();
    let itemId
    try {
      itemId = Number(e.dataTransfer.getData('text/plain'));
    } catch (error) {
      itemId = Number(e.target.value)
    }
    const draggedProperty = property.find((property) => property.id === itemId);

    if (draggedProperty) {
      const updatedProperty = property.filter((property) => property.id !== itemId);
      const updatedSelectedProperty = selectedProperty.filter((property) => property.id !== itemId);

      if (targetList === 'available') {
        setProperty([...updatedProperty, draggedProperty]);
        setSelectedProperty(updatedSelectedProperty);
      } else if (targetList === 'selected') {
        setProperty([...updatedProperty, draggedProperty]);
        setSelectedProperty([...updatedSelectedProperty, draggedProperty]);
      }
    }
  };

  const handleDropSetPermission = (e, targetList) => {
    setPermissionListError('');
    e.preventDefault();
    let itemId
    try {
      itemId = Number(e.dataTransfer.getData('text/plain'));
    } catch (error) {
      itemId = Number(e.target.value)
    }
    const draggedPermission = permission.find((permission) => permission.id === itemId);
  
    if (draggedPermission) {
      const updatedPermission = permission.filter((permission) => permission.id !== itemId);
      const updatedSelectedPermission = selectedPermission.filter((Permission) => Permission.id !== itemId);
  
      if (targetList === 'available') {
        setPermission([...updatedPermission, draggedPermission]);
        setSelectedPermission(updatedSelectedPermission);
      } else if (targetList === 'selected') {
        setPermission([...updatedPermission, draggedPermission]);
        setSelectedPermission([...updatedSelectedPermission, draggedPermission]);
      }
    }
  };
  
  const handleUpdatePopupAsk = () => {
    setSearchPropertyQuery("");
    setSearchPropertyQuery1("");
    setSearchPermissionQuery("");
    setSearchPermissionQuery1("");
    if (!policyName) {
      setPolicyNameError('Please enter policy name');
    }
    if (selectedProperty.length === 0){
      setPropertyListError('Please select property')
    }
    if (selectedPermission.length === 0){
      setPermissionListError('Please select permission')
    }
    if (!policyName || selectedProperty.length === 0 || selectedPermission.length === 0) {
      return
    }
    setConfirmAction('')
    setConfirmActionError('')
    setPopupTitle("Do you want to change group information")
    setPopupLogo("../assets/app/ask.gif")
    setPopupWidth(80);
    setAskUpdatePopup(true);
    setAskDeletePopup(false);
    setOpen(true);
  }

  const handleDeletePopupAsk = () => {
    setConfirmAction('')
    setConfirmActionError('')
    setPopupTitle("Are you sure, you want to remove group")
    setPopupLogo("../assets/app/ask.gif")
    setPopupWidth(80); 
    setAskUpdatePopup(true);
    setAskDeletePopup(true);
    setOpen(true);
  }

  const handleUpdatePolicy = async () => {
    setSearchPropertyQuery("");
    setSearchPropertyQuery1("");
    setSearchPermissionQuery("");
    setSearchPermissionQuery1("");
    if(confirmAction !== policyName){
      setConfirmAction('')
      setConfirmActionError('Policy name does not match');
      return
    }
    if (!policyName) {
      setPolicyNameError('Please enter policy name');
    }
    if (selectedProperty.length === 0){
      setPropertyListError('Please select property')
    }
    if (selectedPermission.length === 0){
      setPermissionListError('Please select permission')
    }
    if (!policyName || selectedProperty.length === 0 || selectedPermission.length === 0) {
      return
    }
    handleClose();
    try {
      setButtonLabel("Loading...");
    
      const propertyIds = selectedProperty.map((item) => item.id);
      const permissionIds = selectedPermission.map((item) => item.id);
      
      const formData = new FormData();
      formData.append("id", policy.policy.data.id);
      formData.append("name", policyName);
      formData.append("properties", JSON.stringify(propertyIds));
      formData.append("features", JSON.stringify(permissionIds));

      const res = await UpdatePolicyMutation({token:getToken(), data:formData });        
      if (res.error) {
        if (res.error.status===400) {
          showToast(false, 'ⓘ', 'Policy already exists');
        } else if (res.error.status===500) {
          showToast(false, 'ⓘ', 'Something went wrong, please try again');
        } else if (res.error.status==="FETCH_ERROR") {
          showToast(false, 'ⓘ', 'Unable to changed policy information, server error');
        } else {
          showToast(false, 'ⓘ', 'Something went wrong, please try again');
        }
      }
      if (res.data) {
        showToast(true, '✔', 'Policy information changed');
      }
    } catch (error) {
      console.error("An unexpected error occurred:", error);
    } finally {
      setButtonLabel("UPDATE");
      handleClose();
      setAskUpdatePopup(false);
      setConfirmAction('')
      setConfirmActionError('')
    }
  };

  const handleDeletePolicy = async () => {
    if(confirmAction !== policyName){
      setConfirmAction('')
      setConfirmActionError('Policy name does not match');
      return
    }
    handleClose();
    try {    
      const actualData = {
        id:policy.policy.data.id,
        token: getToken()
      }
      const res = await DeletePolicyMutation(actualData);

      if (res.error) {
        if (res.error.status===400) {
          showToast(false, 'ⓘ', 'Bad request');
        } else if (res.error.status===500) {
          showToast(false, 'ⓘ', 'Something went wrong, please try again');
        } else if (res.error.status==="FETCH_ERROR") {
          showToast(false, 'ⓘ', 'Unable to remove policy information, server error');
        } else {
          showToast(false, 'ⓘ', 'Something went wrong, please try again');
        }
      }
      if (res.data) {
        showToast(true, '✔', 'Policy information remove');
        setTimeout(() => {
          navigate('/cloud/users', {state:{ dropdownState: 'Policies' }});
        }, 3000);
      }
    } catch (error) {
      console.error("An unexpected error occurred:", error);
    } finally {
      // setButtonLabel("UPDATE");
      handleClose();
      setAskUpdatePopup(false);
      setAskUpdatePopup(false)
      setConfirmAction('')
      setConfirmActionError('')
    }
  };

  const handleCancel = () => {
    setSearchPropertyQuery("");
    setSearchPropertyQuery1("");
    setSelectedProperty([]);
    setSearchPermissionQuery("");
    setSearchPermissionQuery1("");
    setSelectedPermission([]);
  };

  const handleClose = () => {
    setOpen(false);
  };
  
  useEffect(() => {
    setLoading(false);
    try{
      if ( propertyError || permisstionError ) {
        if (propertyError.status === 401 || permisstionError.status === 401) {
          // showToast(false, 'ⓘ', 'Unauthorized User');
        } else {
          showToast(false, 'ⓘ', 'Something went wrong, server error');
        }
      }
      if (propertyData && propretyIsSuccess) {
        setProperty(propertyData.properties)
        setSelectedProperty(policy.policy.data.properties)
      }
      if (permisstionData && permisstionIsSuccess) {
        setPermission(permisstionData.data)
        setSelectedPermission(policy.policy.data.features)
      }
      setPolicyName(policy.policy.data.name)
    } catch(error) {
      console.log(error)
    }
    setTimeout(() => {
      setLoading(true);
    }, 1000);
  }, [ propertyData, propretyIsSuccess, permisstionData, permisstionIsSuccess ]);

  const showToast = (status, symbol, message) => {
    setToasterData({
      trigger: true,
      status,
      symbol,
      message,
    });

    setTimeout(() => {
      setToasterData((prev) => ({
        ...prev,
        trigger: false,
      }));
    }, 5000); 
  };

  return (
    <>
      {toasterData.trigger && (
        <Toaster
          trigger={toasterData.trigger}
          status={toasterData.status}
          symbol={toasterData.symbol}
          message={toasterData.message}
        />
      )}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {popupTitle}
        </DialogTitle>
        <DialogContent>
          <Box
            noValidate
            component="form"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              m: 'auto',
              width: 'fit-content',
            }}
          >
            <img width={popupWidth} src={popupLogo} alt="delete" />
          </Box>
          To confirm action, type policy name <strong style={{ color: '#FF2929' }}>{policyName}</strong>
          <FormControl fullWidth>
            <TextField
              autoFocus
              variant="outlined"
              size="small"
              defaultValue={confirmAction}
              onChange={handleConfirmAction}
              helperText={confirmActionError}
              error={Boolean(confirmActionError)}
            />
          </FormControl>
        </DialogContent>
        <DialogActions>
          {askUpdatePopup?(
            <>
              {askDeletePopup?(
                <Button onClick={() => handleDeletePolicy()}>
                  Yes
                </Button>
              ):(
                <Button onClick={() => handleUpdatePolicy()}>
                  Yes
                </Button>
              )}
              <Button onClick={handleClose}>
                No
              </Button>
            </>
          ):(
            <></>
          )}
        </DialogActions>
      </Dialog>
      <Grid item sx={{ width: '250%' }}>
          <FormControl sx={{ mt: 1 }} fullWidth size="small">
            <TextField
              label="Policy Name"
              variant="outlined"
              size="small"
              value={policyName}
              onChange={handlePolicyName}
              helperText={policyNameError}
              error={Boolean(policyNameError)}
              autoComplete="off"
            />
          </FormControl>

          <Box
              component="form"
              sx={{
              '& .MuiTextField-root': { m: 4, width: '30ch' },
              my: 3,
              }}
              noValidate
              autoComplete="off"
          >
              <List
                name="Property"
                items={property}
                selectedItems={selectedProperty}
                searchQuery={searchPropertyQuery}
                searchQuery1={searchPropertyQuery1}
                handleDragStart={handleDragStartProperty}
                handleDropItems={handleDropSetProperty}
                filteredItems={filteredProperty}
                filteredSelectedItems={filteredSelectedProperty}
                onSearchQueryChange={(e) => setSearchPropertyQuery(e.target.value)}
                onSearchQuery1Change={(e) => setSearchPropertyQuery1(e.target.value)}
              />
              <Typography style={{ color: '#FF4842', fontSize: '12px', marginLeft: '1%' }}>{propertyListError} </Typography>
          </Box>
          
          <Box
              component="form"
              sx={{
              '& .MuiTextField-root': { m: 4, width: '30ch' },
              my: 3,
              }}
              noValidate
              autoComplete="off"
          >
              <List
                name="Permission"
                items={permission}
                selectedItems={selectedPermission}
                searchQuery={searchPermissionQuery}
                searchQuery1={searchPermissionQuery1}
                handleDragStart={handleDragStartPermission}
                handleDropItems={handleDropSetPermission}
                filteredItems={filteredPermission}
                filteredSelectedItems={filteredSelectedPermission}
                onSearchQueryChange={(e) => setSearchPermissionQuery(e.target.value)}
                onSearchQuery1Change={(e) => setSearchPermissionQuery1(e.target.value)}
              />
              <Typography style={{ color: '#FF4842', fontSize: '12px', marginLeft: '1%' }}>{permissionListError}</Typography>
          </Box>
          
          {policy?.policy?.data ? (
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={6} xl={6}>
                <TextField
                  fullWidth
                  disabled
                  id="standard-disabled"
                  label="Created By Name"
                  value={`${policy.policy.data.createdBy.first_name} ${policy.policy.data.createdBy.last_name}`}
                  variant="outlined"
                  size="small"
                  sx={{ my: 1 }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={6} xl={6}>
                <TextField
                  fullWidth
                  disabled
                  id="standard-disabled"
                  label="Modified By Name"
                  value={`${policy.policy.data.modifiedBy.first_name} ${policy.policy.data.modifiedBy.last_name}`}
                  variant="outlined"
                  size="small"
                  sx={{ my: 1 }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={6} xl={6}>
                <TextField
                  fullWidth
                  disabled
                  id="standard-disabled"
                  label="Created By Email"
                  value={policy.policy.data.createdBy.email}
                  variant="outlined"
                  size="small"
                  sx={{ my: 1 }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={6} xl={6}>
                <TextField
                  fullWidth
                  disabled
                  id="standard-disabled"
                  label="Modified By Email"
                  value={policy.policy.data.modifiedBy.email}
                  variant="outlined"
                  size="small"
                  sx={{ my: 1 }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={6} xl={6}>
                <TextField
                  fullWidth
                  disabled
                  id="standard-disabled"
                  label="Created On Date"
                  value={formatDate(policy.policy.data.createdOn)}
                  variant="outlined"
                  size="small"
                  sx={{ my: 1 }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={6} xl={6}>
                <TextField
                  fullWidth
                  disabled
                  id="standard-disabled"
                  label="Modified On Date"
                  value={formatDate(policy.policy.data.modifiedOn)}
                  variant="outlined"
                  size="small"
                  sx={{ my: 1 }}
                />
              </Grid>
            </Grid>
          ) : (
            <Typography variant="body2">Loading...</Typography>
          )}

          <Grid item xs={12}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row-reverse',
                mt: 2
              }}
            >
              <FormControl sx={{width: { xs: '100%', sm: '100%', md:'16.5%', xl:'16.5%' }}}>
                <Button
                  onClick={handleCancel}
                  sx={{
                    color: '#9BA4B5',
                    border: 1,
                    borderColor: '#B5C0D0',
                    bgcolor: '#FFF',
                    ":hover": {
                        bgcolor: "#EEEEEE",
                        borderColor: '#EEEEEE',
                    }
                  }}
                  >
                  CLEAR
                </Button>
              </FormControl>
              <FormControl sx={{width: { xs: '100%', sm: '100%', md:'16.5%', xl:'16.5%' }}}>
                <Button
                  onClick={() => handleDeletePopupAsk()}
                    sx={{
                      color: '#FFF',
                      border: 1,
                      borderColor: '#E74646',
                      bgcolor: '#E74646',
                      marginRight:2,
                      ":hover": {
                          bgcolor: "#BB2525",
                          borderColor: '#BB2525',
                      }
                    }}>
                  DELETE
                </Button>
              </FormControl>
              <FormControl sx={{width: { xs: '100%', sm: '100%', md:'16.4%', xl:'16.4%' }}}>
                <Button
                    onClick={() => handleUpdatePopupAsk()}
                    disabled={buttonLabel==="Loading..."}
                    sx={{
                      color: '#FFF',
                      border: 1,
                      borderColor: '#A8A196',
                      bgcolor: '#A8A196',
                      marginRight:2,
                      ":hover": {
                          bgcolor: "#7D7463",
                          borderColor: '#7D7463',
                      }
                    }}>
                  {buttonLabel}
                </Button>
              </FormControl>
            </Box>
          </Grid> 
      </Grid>
    </>
  );
};
export default Update;
